export default __webpack_public_path__ + "static/media/instagram.987a82aa.svg";